import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const ModalContent = (props) => {
    const { children, className = '', contentClassName = '' } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex justify-center', 'pt-32 px-20 pb-40', className) }, { children: _jsx("div", Object.assign({ className: clsx('w-full max-w-[min(500px,100%)]', contentClassName) }, { children: children })) })));
};
